import { ComponentPropsWithoutRef } from 'react';

export const ImgUploadIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 44 48" fill="none">
      <path d="M16 2.464a12 12 0 0 1 12 0l9.65 5.572a12 12 0 0 1 6 10.392v11.144a12 12 0 0 1-6 10.392L28 45.536a12 12 0 0 1-12 0l-9.65-5.572a12 12 0 0 1-6-10.392V18.428a12 12 0 0 1 6-10.392L16 2.464Z" />
      <path d="M16.25 2.897a11.5 11.5 0 0 1 11.5 0L37.4 8.47a11.5 11.5 0 0 1 5.75 9.96v11.143a11.5 11.5 0 0 1-5.75 9.96l-9.65 5.57a11.5 11.5 0 0 1-11.5 0l-9.65-5.57a11.5 11.5 0 0 1-5.75-9.96V18.428a11.5 11.5 0 0 1 5.75-9.96l9.65-5.57Z" />
    </svg>
  );
};
